'use strict';

app.filter('timestamp', function () {
  function timestamp (value) {
    var delta = Date.now() - Date.parse(value);
    var seconds  = Math.floor(delta / 1000);
    var minutes  = Math.floor(seconds / 60);
    var hours    = Math.floor(minutes / 60);
    var days     = Math.floor(hours / 24);
    var weeks    = Math.floor(days / 7);
    var months   = Math.floor(days / 30);
    return (seconds < 45) ? 'few moments ago'
      : (seconds < 90) ? 'a minute ago'
      : (minutes < 45) ? minutes + ' minutes ago'
      : (minutes < 90) ? 'an hour ago'
      : (hours < 22)   ? hours + ' hours ago'
      : (hours < 36)   ? 'a day ago'
      : (days < 7)     ? days + ' days ago'
      : (weeks < 2)    ? 'a week ago'
      : (weeks < 4)    ? weeks + ' weeks ago'
      : (months < 2)   ? 'a months ago'
      : (months < 12)  ? months + ' months ago'
      :                  'over a year ago';
  }
  timestamp.$stateful = true;
  return timestamp;
});
